var _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 20.75C18.8221 21.1806 19.233 21.5369 19.7049 21.7947C20.1768 22.0525 20.6986 22.2058 21.235 22.2442C21.7713 22.2826 22.3097 22.2052 22.8135 22.0173C23.3173 21.8294 23.7748 21.5353 24.155 21.155L26.405 18.905C27.0881 18.1977 27.4661 17.2505 27.4575 16.2672C27.449 15.284 27.0546 14.3434 26.3593 13.6482C25.664 12.9529 24.7235 12.5585 23.7403 12.5499C22.757 12.5414 21.8098 12.9194 21.1025 13.6025L19.8125 14.885",
    stroke: "#4E7A8C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5001 19.2499C21.1781 18.8193 20.7671 18.463 20.2952 18.2052C19.8233 17.9474 19.3015 17.7941 18.7652 17.7557C18.2288 17.7173 17.6905 17.7946 17.1866 17.9826C16.6828 18.1705 16.2253 18.4646 15.8451 18.8449L13.5951 21.0949C12.9121 21.8022 12.5341 22.7494 12.5426 23.7327C12.5512 24.7159 12.9455 25.6565 13.6408 26.3517C14.3361 27.047 15.2767 27.4414 16.2599 27.45C17.2431 27.4585 18.1904 27.0805 18.8976 26.3974L20.1801 25.1149",
    stroke: "#4E7A8C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChain);
export default __webpack_public_path__ + "static/media/chain.dfda60b1.svg";
export { ForwardRef as ReactComponent };